import { render, staticRenderFns } from "./RandomChatCordova.vue?vue&type=template&id=c6e7d9bc&"
import script from "./RandomChatCordova.vue?vue&type=script&lang=js&"
export * from "./RandomChatCordova.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports